export default {
  collectionAddress: 'Collection address',
  distributeStrategy: 'Distribute strategy',
  amount: 'Amount',
  chooseToken: 'Choose a token',
  message: 'Message',
  excludeOwnerCollection: 'Exclude owner collection',
  excludeNftSale: 'Exclude NFT Sale',
  address: 'Address',
  count: 'Count',
  token: 'Token',
  nftOwnerAddress: 'Nft owner address',
  datetime: 'Date time',
  dateFrom: 'Date from',
  dateTo: 'Date to',
  accountId: 'Account ID',
  distributeToken: 'Distribute token',
  search: 'Search',
  searchByName: 'Search by name',
  transactionToken: 'Transaction token',
  type: 'Type',
  explain: 'Explain',
  externalAccount: 'External account',
  filters: 'Filters',
  owner: 'Owner',
  inSale: 'In sale',
  distribute: 'Distribute',
  result: 'Result',
  save: 'Save',
  selectToken: 'Select a token',
  include: 'Include',
  exclude: 'Exclude',
  send: 'Send',
  receive: 'Receive',
};
